// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  administrative: (t, data?, options?) => t('enum.booking-cancellation-type.administrative.name', data, options),
  student: (t, data?, options?) => t('enum.booking-cancellation-type.student.name', data, options),
  teacher: (t, data?, options?) => t('enum.booking-cancellation-type.teacher.name', data, options),
  /* eslint-enable max-len */
};
